import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
	type CreateScheduleNoteInput,
	createScheduleNote,
	type UpdateScheduleNoteInput,
	updateScheduleNote,
} from "@/adapters/api";

export type SaveScheduleNoteVariables =
	| { kind: "create"; input: CreateScheduleNoteInput }
	| { kind: "update"; noteId: string; input: UpdateScheduleNoteInput };

export function useSaveScheduleNote(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: SaveScheduleNoteVariables) => {
			if (!constructionId) throw new Error("missing construction");
			if (variables.kind === "update") {
				return updateScheduleNote(
					constructionId,
					variables.noteId,
					variables.input,
				);
			}
			return createScheduleNote(constructionId, variables.input);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ["schedule-notes", constructionId],
			});
		},
	});
}
